import { AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from 'react';


interface IProps {
    isLoading?: boolean;
    title: string;
    children: JSX.Element;
    accordionExpanded: any;
    handleAccordionChange: any
  }

const AccordionGeneral = (props: IProps) => {
  const { title, children, accordionExpanded, handleAccordionChange } = props;
  
  return (
    <>
      <Accordion sx={{minWidth: '160px'}} expanded={accordionExpanded} 
        onChange={handleAccordionChange}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={'panelbh-content'}
          id={'panelbh-header'}
        >
          <Typography variant='h4' sx={{ width: '100%', flexShrink: 0 }}>
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {children}
        </AccordionDetails>
      </Accordion>
  
    </> 
  );
     
};

export default AccordionGeneral;